import { Injectable, NgZone } from '@angular/core';
import {
  HttpClient, HttpParams, HttpHeaders
} from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { ServiceBase } from './base.service';
import { User } from '../models/usuario.model';
import { AuthService } from './auth.service';
import { Data } from '../providers/data';
import { Observable } from 'rxjs';


@Injectable()
export class PrestadorService {
  constructor(
    public http: HttpClient,
    public serviceBase: ServiceBase,
    public authService: AuthService,
    public data: Data,


  ) {}

  urlService = this.serviceBase.getUrlApi('supplier');

  obtenerPrestadoresById(id): Observable<any>{
    return this.http.get<any>(`${this.urlService}ById/${id}`)
    .pipe(
      map((response) => response ),
      catchError(this.serviceBase.handleError)
    );
  }
  obtenerPrestadoresByCodigo(codigo): Observable<any>{
    return this.http.get<any>(`${this.urlService}byCode/${codigo}`)
    .pipe(
      map((response) => response ),
      catchError(this.serviceBase.handleError)
    );
  }

}
